'use client';

import { useIntl } from 'react-intl';
import {
  PriceUnitPrice,
  type PriceUnitPriceProps,
} from '@packages/shared/src/ui/Price/PriceUnitPrice/PriceUnitPrice';
import { priceUnitPriceMessages } from './messages';

type PriceUnitPriceLocalizedProps = Omit<PriceUnitPriceProps, 'aria-label'>;

export const PriceUnitPriceLocalized = (props: PriceUnitPriceLocalizedProps) => {
  const { formatMessage } = useIntl();

  return <PriceUnitPrice {...props} aria-label={formatMessage(priceUnitPriceMessages.unitPrice)} />;
};
